import moment from 'moment';

import { Report as ActionTypes } from '../actionTypes';
import { time as constant } from '../../constants';

const create = payload => ({
  type: ActionTypes.CREATE,
  payload: {
    ...payload,
    UpdateDate: moment().format(constant.CREATE),
  },
});

const override = payload => ({
  type: ActionTypes.OVERRIDE,
  payload,
});

const remove = payload => ({
  type: ActionTypes.REMOVE,
  payload,
});

const update = payload => ({
  type: ActionTypes.UPDATE,
  payload: {
    ...payload,
    Data: {
      ...payload.Data,
      UpdateDate: moment().format(constant.CREATE),
    },
  },
});

export default {
  create,
  override,
  remove,
  update,
};
